let loading = null;

export function loadJQueryDataTables() {
  if (!loading) {
    loading = import('./jquery_datatables').catch((error) => {
      loading = null;
      throw error;
    });
  }
  return loading;
}

export function whenJQueryDataTables(callback) {
  const page = document.body;
  return loadJQueryDataTables().then(() => {
    if (document.body === page) callback();
  });
}
